import { createContext } from "react";

export const TaskContext = createContext();

export const TaskProvider = TaskContext.Provider;
export const TaskConsumer = TaskContext.Consumer;
